// WidgetRenderer.tsx (gerçek component renderer)
import React from 'react';
import {WidgetMap} from '../pages/Dashboard/widgets/WidgetMap';

interface WidgetRendererProps {
    componentKey: string;
    rowSpan?: number;
    colSpan?: number;
}

const getWidgetMode = (rowSpan: number, colSpan: number): 'big' | 'middle' | 'small' => {
    const key = `${rowSpan}x${colSpan}`;
    switch (key) {
        case '1x1':
            return 'big';
        case '1x2':
        case '2x1':
        case '3x1':
            return 'middle';
        default:
            return 'small';
    }
};

const WidgetRenderer: React.FC<WidgetRendererProps> = ({componentKey, rowSpan = 1, colSpan = 1}) => {
    const Component = WidgetMap[componentKey];
    const mode = getWidgetMode(rowSpan, colSpan);
    return Component ? <Component mode={mode} colSpan={colSpan} rowSpan={rowSpan}/> :
        <div>Tanımsız Widget: {componentKey}</div>;
};

export default WidgetRenderer;
